var _circle, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepsCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.23,
    cx: 12.1769,
    cy: 12.0002,
    r: 11.2941,
    fill: "#D0D8DC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.64746,
    y: 6.35303,
    width: 7.05882,
    height: 1.41176,
    rx: 0.705882,
    fill: "#7E898F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.64746,
    y: 16.2358,
    width: 7.05882,
    height: 1.41176,
    rx: 0.705882,
    fill: "#7E898F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.23535,
    y: 10.5884,
    width: 9.88235,
    height: 2.82353,
    rx: 1.41176,
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepsCount);
export default __webpack_public_path__ + "static/media/RepsCount.d8d11f07fe078a82dbf59ca13cd00529.svg";
export { ForwardRef as ReactComponent };